import { createContext, useContext, useEffect, useState } from "react";

const KEY = "bcp_cart_v1";
const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(KEY);
      if (raw) setItems(JSON.parse(raw));
    } catch {
      // ignore
    }
  }, []);

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const addItem = (product, qty = 1) => {
    setItems((cur) => {
      const i = cur.findIndex((x) => x.product_id === product.id);
      if (i >= 0) {
        const next = [...cur];
        next[i] = { ...next[i], qty: next[i].qty + qty };
        return next;
      }
      return [
        ...cur,
        {
          product_id: product.id,
          sku: product.sku,
          name: product.name,
          price: Number(product.negotiated_price ?? product.price) || 0,
          image_url: product.image_url || "",
          qty,
        },
      ];
    });
  };

  const updateQty = (product_id, qty) =>
    setItems((cur) =>
      cur
        .map((x) => (x.product_id === product_id ? { ...x, qty: Math.max(1, qty) } : x))
        .filter((x) => x.qty > 0)
    );

  const removeItem = (product_id) =>
    setItems((cur) => cur.filter((x) => x.product_id !== product_id));

  const clear = () => setItems([]);

  const count = items.reduce((s, i) => s + i.qty, 0);
  const subtotal = items.reduce((s, i) => s + i.price * i.qty, 0);

  return (
    <CartContext.Provider value={{ items, addItem, updateQty, removeItem, clear, count, subtotal }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);